import {BookingStepBase} from "./booking-step.base";
import {ICheckInRoutes} from "../../../navigation/routes/check-in/check-in.routes.interface";

export abstract class CheckInFlowStepBase extends BookingStepBase {
    protected get routes(): ICheckInRoutes {
        return this.services.navigator.routes.checkIn;
    }
}
